/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_Select_Guide_LabelInputs */



/**
* | output |
* | --- |
* | "Select KNP Guide" |
*
* @param {Knp_Lookup_Select_Guide_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_select_guide_label = /** @type {((inputs?: Knp_Lookup_Select_Guide_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Select_Guide_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionner un guide KNP")
	if (locale === "de") return /** @type {LocalizedString} */ ("KNP-Reiseführer auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona la guida KNP")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите путеводитель по КНП")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar la Guía KNP")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择 KNP 指南")
	if (locale === "ja") return /** @type {LocalizedString} */ ("KNPガイドを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केएनपी गाइड चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione o Guia do Parque Nacional Kruger")
	return /** @type {LocalizedString} */ ("Select KNP Guide")
});